<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation class="print:hidden"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="navigation.default"
                          [opened]="!isScreenSmall"
                          style="background-color:#002b40 !important; color:#fff !important">
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <div class="flex items-center ml-auto">
                <user [showAvatar]="true"></user>
            </div>
        </div>
        <div class="flex flex-col items-center w-full p-4">
            <div class="relative w-24 h-24">
                <img class="w-full h-full rounded-full" *ngIf="user?._profileImage" [src]="user?._profileImage">
                <mat-icon class="icon-size-24" *ngIf="!user?._profileImage" [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </div>
            <div class="flex flex-col items-center justify-center w-full mt-6 mb-6">
                <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center text-xl leading-normal font-medium capitalize">
                    {{user?.displayName}}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-sm leading-normal font-extralight">
                    {{user?.emailAddress}}
                </div>
                @if (!isHideStatusUserProfile) {
                <div class="mt-2 whitespace-nowrap text-ellipsis overflow-hidden text-center text-sm leading-normal font-extralight">
                    <span (click)="openPersonStatus()" [style.background-color]="user?.personStatusColour"
                          class="flex items-center justify-center py-1 px-3 rounded-full leading-normal cursor-pointer border-solid {{ getPersonStatusTextColor() }}">
                        <span class="font-normal whitespace-nowrap text-sm">{{user?.personStatusDisplay}}</span>
                    </span>
                </div>
                }
            </div>
            <div (click)="openWorkdayPlan()" class="w-full">
                <workday-plan [personId]="user?.personId" [colorScheme]="'light'" [isReadOnly]="true" (workDayUpdated)="onWorkDayUpdated()" [isCursorPointer]="true"></workday-plan>
            </div>
        </div>

        <div class="w-full text-right pr-2" style="letter-spacing: 1px;font-size:9px !important; position:absolute; bottom: 4px;">
            {{version}}
        </div>
    </ng-container>

</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow bg-card print:hidden" style="background-color:#fff !important;">
        <button (click)="toggleNavigation('mainNavigation')" class="mr-2" mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex items-center pl-2 mr-auto space-x-0.5 sm:space-x-2">
            <ng-container *ngIf="shell$ | async as shell">
                <span class="text-2xl md:text-2xl font-extrabold uppercase tracking-tight text-center" style="color:#000f70 !important;">
                    {{shell.title}}
                </span>
            </ng-container>
        </div>
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
            <search [searchHandler]="searchHandler" [appearance]="'bar'"></search>
        </div>
        <div *ngIf="_router.url.indexOf('/calendar') != -1">
            <calendar-filter></calendar-filter>
        </div>
    </div>

    <div class="flex flex-col flex-auto" style="background-color:#fff !important;">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
        <add-new></add-new>
    </div>

</div>
